import React, { useCallback } from 'react'

import {
  clearSearchAndFetch,
  selectIsMdsSearchEnabled,
  selectSearchPage,
  setFilters,
} from '@disco/state-management/reducers/search-page'

import type { FilterState } from 'types/filter-page'

import { useDispatch, useSelector } from 'hooks/use-redux'

import FilterBar from './filter-bar'
import SourceFilterButton from './source-filter-button'

/** Binds the shared filter bar to the search page's own state. */
const SearchFilters = (): React.ReactNode | null => {
  const dispatch = useDispatch()
  const { filters, query } = useSelector(selectSearchPage)
  const mdsSearchEnabled = useSelector(selectIsMdsSearchEnabled)

  const handleFiltersChange = useCallback(
    (value: FilterState[]) => dispatch(setFilters(value)),
    [dispatch],
  )
  const handleClearAll = useCallback(
    (clearedFilters: FilterState[]) => {
      void dispatch(clearSearchAndFetch(clearedFilters))
    },
    [dispatch],
  )

  return (
    <FilterBar
      filters={filters}
      hasQuery={!!query}
      onChange={handleFiltersChange}
      onClearAll={handleClearAll}
      afterAddButton={mdsSearchEnabled ? <SourceFilterButton /> : undefined}
    />
  )
}

export default SearchFilters
